import { apiClient } from 'v4/core/apiClient';
import { createShortlistsApi } from 'v4/entities/shortlist/shortlist.http';

export const shortlistsApiSingleton = createShortlistsApi(apiClient, true);
